import { useStartBillingPortal, useStartCheckout } from '../../services/api/subscription.hooks'
import { icons } from '../../styles/images'
import GTButton, { GTButtonProps } from '../atoms/buttons/GTButton'

interface SubscriptionButtonProps {
    styleType?: GTButtonProps['styleType']
    value?: string
    fitContent?: boolean
}

export const SubscribeButton = ({ styleType = 'primary', value = 'Subscribe', fitContent }: SubscriptionButtonProps) => {
    const { mutate: startCheckout, isLoading } = useStartCheckout()

    return (
        <GTButton
            type="button"
            styleType={styleType}
            icon={icons.external_link}
            value={isLoading ? 'Opening...' : value}
            disabled={isLoading}
            fitContent={fitContent}
            onClick={() => startCheckout()}
        />
    )
}

export const ManageBillingButton = ({
    styleType = 'secondary',
    value = 'Manage subscription',
    fitContent,
}: SubscriptionButtonProps) => {
    const { mutate: startBillingPortal, isLoading } = useStartBillingPortal()

    return (
        <GTButton
            type="button"
            styleType={styleType}
            icon={icons.external_link}
            value={isLoading ? 'Opening...' : value}
            disabled={isLoading}
            fitContent={fitContent}
            onClick={() => startBillingPortal()}
        />
    )
}
